<template>
    <df-app>
        <div class="home-video">
            <div class="home-video__container">
                <div class="home-video__frame" v-if="!isGrfSystem && !isHeidilandSystem">
                    <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/77ZJlD8kB8E" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 col-xl-8 mt-5">
                <be-card divider v-if="isHeidilandSystem">
                    <div class="card-title text-uppercase" slot="header">Ihre Vorteile</div>
                    <div class="row home-list">
                        <div class="col-xl-6">
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Standortbestimmung Ihres digitalen Fitness-Zustandes</span>
                            </div>
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Vergleich mit anderen Betrieben</span>
                            </div>
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Konkrete Handlungsempfehlungen</span>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Konkrete Umsetzungsvorschläge, bestehend aus Video-Tutorials, Softwarelösungen oder Promitions-Tipps</span>
                            </div>
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Persönliche und neutrale Beratung vor Ort</span>
                            </div>
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Vertiefte Beratung und Coaching durch den Heidiland Digital-Coach möglich</span>
                            </div>
                        </div>
                    </div>
                </be-card>
                <be-card divider v-else>
                    <div class="card-title text-uppercase" slot="header">Ihre Vorteile</div>
                    <div class="row home-list">
                        <div class="col-xl-6">
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Standortbestimmung Ihres digitalen Fitness-Zustandes.</span>
                            </div>
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Konkrete Handlungsempfehlungen für mehr Conversions.</span>
                            </div>
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Vergleich mit anderen Unternehmen.</span>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Persönliche und neutrale Beratung vor Ort.</span>
                            </div>
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Zertifizierte IT-Experten mit jahrenlanger Branchenerfahrung.</span>
                            </div>
                            <div class="icon-container p-2">
                                <div class="icon"><span class="mdi mdi-check"></span></div>
                                <span class="icon-class">Umsetzung von Sofortmassnahmen.</span>
                            </div>
                        </div>
                    </div>
                </be-card>
            </div>
            <div class="col-md-6 col-xl-4 mt-5 home-action">
                <h2 class="page-head-title">Wie Digital.FIT sind Sie?</h2>
                <div>
                    <h3 class="home-action__text" v-if="isHeidilandSystem">Finden Sie es heraus mit dem Digital Fitness Check von Heidiland Tourismus.</h3>
                    <h3 class="home-action__text" v-else>Finden Sie es heraus mit einer kostenlosen Standortbestimmung.</h3>
                    <router-link :to="{ name: 'check' }" class="btn btn-primary btn-lg mt-2 home-action__button"><i class="icon mdi mdi-assignment-o"></i> Jetzt Digital.Check starten</router-link>
                </div>
            </div>
        </div>
    </df-app>
</template>

<script>
    import env from '../../mixins/env';

    export default {
        mixins: [env],
    };
</script>


<style rel="stylesheet/scss" lang="scss">
    .home-video {
        position: relative;
        overflow: visible;
        width: calc(100% + 50px);
        height: 0;
        padding-bottom: 60%;
        margin: -25px -25px 0;
        background-size: cover;

        @if(env('VUE_APP_ENV') == 'grf') {
            background-image: url("../../assets/images/home-attention--grf.png");
        } @else if(env('VUE_APP_ENV') == 'heidiland') {
            background-image: url("../../assets/images/home-attention--heidiland.png");
            padding-bottom: 62.518740%;
        } @else {
            background: url("../../assets/images/home-attention.svg") left top no-repeat;
        }

        &__container {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 60%;
            max-width: 750px;
            transform: translate3d(-50%, -50%, 0);
        }

        &__frame {
            position: relative;
            height: 0;
            padding-bottom: 56.25%;

            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }

    }

    .home-action {
        @if(env('VUE_APP_ENV') == 'heidiland') {
            min-height: 500px;
            background: url("../../assets/images/heidi.png") 100% 20% no-repeat;
            background-size: 40% auto;
        } @else if(env('VUE_APP_ENV') != 'grf') {
            min-height: 500px;
            background: url("../../assets/images/tarzan.svg") 100% 0 no-repeat;
            background-size: 40% 90%;
        }

        &__text {
            line-height: 1.4;

            @if(env('VUE_APP_ENV') != 'grf') {
                padding-right: 40%;
            }
        }

        &__button {
            margin-top: 3rem !important;
            font-size: 1.6rem;
            line-height: 2.2em;
        }
    }

    .home-list {
        .icon-container {
            &:after {
                display: table;
                clear: both;
                content: "";
            }

            .icon {
                float: left;
            }

            .icon-class {
                display: block;
                margin-left: 70px;
            }
        }
    }
</style>
